import React from 'react';
import TeamMemberList from './TeamMemberList';
import Button from '../common/Button';

function ProposalTeamSection({ context, setContext, onSave, saving }) {
  const handleTeamMembersChange = (newTeamMembers) => {
    setContext({ ...context, proposal_team: newTeamMembers });
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h2 className="text-2xl font-bold text-gray-800 mb-2">Proposal Team</h2>
      <p className="text-gray-600 text-sm mb-6">Add team members who participated in the IPA workshop and will be listed in the report.</p>

      <TeamMemberList
        teamMembers={context.proposal_team || []}
        onChange={handleTeamMembersChange}
      />

      <Button
        variant="primary"
        onClick={onSave}
        disabled={saving || !context.customer}
        className="w-full mt-6"
      >
        {saving ? 'Saving...' : 'Save Team'}
      </Button>

      {!context.customer && (
        <p className="text-sm text-gray-500 mt-2">
          Save customer context first before adding team members
        </p>
      )}
    </div>
  );
}

export default ProposalTeamSection;
